/* @jsx jsx */
import { css, jsx } from '@emotion/react';
import {
  sizes,
  Spacer,
  TypeRampV2,
  Tag,
  colors,
} from '@smartsheet/lodestar-core';
import { CloseIcon } from '@smartsheet/lodestar-icons';
import { useSelector } from 'react-redux';
import { selectedElementSelector } from '../../../../../services/ducks/designerDuck/designerDuck';
import { selectExtensionByUUID } from '../../../../../services/ducks/extensionsDuck/extensionsDuck';
import { selectModuleById } from '../../../../../services/ducks/modulesDuck/modulesDuck';
import { Column } from '../../../../common/Column';
import { PanelButton } from '../../../../common/Panel/styled/PanelButton';
import { RemoteImage } from '../../../../common/RemoteImage/RemoteImage';

const panelHeaderContainerStyle = css`
  padding-bottom: ${sizes.large}px;
`;

export const ModulePanelHeader = ({
  onClose,
  selectedElement,
}: {
  onClose: { (): void };
  selectedElement: ReturnType<typeof selectedElementSelector>;
}) => {
  const selectedExtension = useSelector(
    selectExtensionByUUID(selectedElement.pluginUUID)
  );
  const selectedModule = useSelector(
    selectModuleById(selectedElement.moduleID, selectedElement.pluginUUID)
  );

  const title = selectedModule.name;
  const subtitle = selectedExtension.displayName;
  const icon = selectedExtension.logoName?.split('.')[0] + '.svg';

  const isCustom = !selectedModule?.isSystem;

  const panelItemsSpacingStyle = css`
    justify-content: space-between;
    margin-bottom: ${sizes.small}px;
  `;

  const subtitleContainer = css`
    padding-bottom: ${sizes.large}px;
  `;

  const subtitleStyle = css`
    font-size: 20px !important;
    line-height: 24px !important;
    margin-right: ${sizes.xSmall}px;
  `;

  return (
    <div css={panelHeaderContainerStyle}>
      <Spacer orientation="row" space="small" css={panelItemsSpacingStyle}>
        <Column>
          {selectedExtension.logoName ? (
            <RemoteImage
              url={`https://assets.bridge.smartsheet.com/images/module-logos/${icon}`}
              style={{ margin: 5, maxHeight: 14, maxWidth: 14 }}
              altText={`${subtitle} logo`}
            />
          ) : null}
          <TypeRampV2 system="lodestar" variant="headerSmall">
            {title}
          </TypeRampV2>
        </Column>
        <Column
          css={css`
            justify-content: flex-end;
          `}
        >
          <PanelButton onClick={onClose}>
            <CloseIcon />
          </PanelButton>
        </Column>
      </Spacer>
      <div css={subtitleContainer}>
        <TypeRampV2
          system="lodestar"
          variant="headlineMedium"
          css={subtitleStyle}
        >
          {subtitle}
        </TypeRampV2>
        {isCustom ? (
          <Tag
            color={{
              backgroundColor: colors.neutralLight10,
              textColor: colors.neutralDark40,
            }}
          >
            Custom Build
          </Tag>
        ) : null}
      </div>
      <div>
        <TypeRampV2 system="lodestar" variant="bodyText">
          {selectedModule.description}
        </TypeRampV2>
      </div>
    </div>
  );
};
